import { render } from "./HospitalizationsRow.vue?vue&type=template&id=bfbd5d14&ts=true"
import script from "./HospitalizationsRow.ts?vue&type=script&lang=ts&external"
export * from "./HospitalizationsRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__